import { FC } from 'react'
import { useField } from 'react-final-form'

import UrlFileFiled from '../molecules/UrlFileField'

type Props = {
  isConfirm: boolean
  required?: boolean
}

const NAME_PREFIX = 'skillSheet'

const SkillSheetField: FC<Props> = ({ isConfirm, required = false }) => {
  const {
    input: { value: dataValue },
  } = useField(`${NAME_PREFIX}.data`)

  const {
    input: { value: urlValue },
  } = useField(`${NAME_PREFIX}.url`)

  if (isConfirm && !dataValue && !urlValue) return null

  return (
    <div data-cy='skillSheet'>
      <UrlFileFiled
        label='スキルシート'
        namePrefix={NAME_PREFIX}
        isConfirm={isConfirm}
        helperText='職務経歴書や資格などのスキルに関する情報をまとめた書類をWordやPDFなどのデータでアップロードするか、それに相当するURLを記入してください。'
        urlPlaceholder='スキルシートのURLを入力してください'
        required={required}
      />
    </div>
  )
}

SkillSheetField.displayName = 'skillSheet'

export default SkillSheetField
